import AppInitializer from './AppInitializer';

export default AppInitializer;
